import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

function VerificarCuenta() {
    const { token } = useParams();
    const [mensaje, setMensaje] = useState({ texto: 'Verificando tu cuenta...', tipo: 'info' });

    useEffect(() => {
        const verificarToken = async () => {
            if (!token) {
                setMensaje({ texto: 'No se proporcionó un token de verificación.', tipo: 'error' });
                return;
            }

            try {
                // --- MODIFICADO ---
                const response = await fetch(`/api/verificar/${token}`);
                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.message || 'Error al verificar la cuenta.');
                }

                setMensaje({ texto: `✅ ${data.message}`, tipo: 'exito' });

            } catch (error) {
                setMensaje({ texto: `❌ ${error.message}`, tipo: 'error' });
            }
        };

        verificarToken();
    }, [token]);

    const getAlertClass = () => {
        if (mensaje.tipo === 'exito') return 'alert-success';
        if (mensaje.tipo === 'error') return 'alert-danger';
        return 'alert-info';
    };

    return (
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <div className="card shadow p-4 text-center" style={{ width: '100%', maxWidth: '500px' }}>
                <h2>Verificación de Cuenta</h2>
                <div className={`alert ${getAlertClass()} mt-3`}>
                    {mensaje.texto}
                </div>
                {mensaje.tipo === 'exito' && (
                    <Link to="/login" className="btn btn-primary mt-3">
                        Ir a Iniciar Sesión
                    </Link>
                )}
            </div>
        </div>
    );
}

export default VerificarCuenta;